<template>
  <div>
    <useTable
      :searchForm="searchForm"
      :httprequest="httprequest"
      ref="useTable"
      :headerList="headerData"
    ></useTable>
  </div>
</template>

<script>
import useTable from "@/components/useTable/useTable.vue";
import { mapActions } from "vuex";
export default {
  data() {
    const statusList = [
      {
        label: "全部",
        value: "",
      },
      {
        label: "已使用",
        value: 11,
      },
      {
        label: "未使用",
        value: 10,
      },
    ];
    return {
      classNames: "coupon",
      headerData: [
        {
          props: {
            prop: "",
            label: "抖音头像",
            width: 150,
          },
          render: (h, scope) => {
            return (
              <div>
                <img src={scope.row.user_info.avatar_url} style="width:36px; border-radius:10px"></img>
              </div>
            );
          },
        },
        {
          props: {
            prop: "",
            label: "昵称"
          },
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.user_info.nickname}</span>
              </div>
            );
          }
        },
        {
          props: {
            prop: "use_range",
            label: "手机号",
            width: 150,
          },
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.user_info.mobile}</span>
              </div>
            );
          },
        },
        {
          props: {
            prop: "coupon_status_desc",
            label: "状态",
            width: 150,
          }
        },
      ],
      searchParams: {
        limit: 10,
        page: 1,
      },
      searchForm: [
      {
          defaultValue: "",
          label: "使用状态",
          Component: "el-select",
          prop: "status",
          span: 7,
          componentProps: {
            placeholder: "请选择状态",
          },
          on: {
            change: (value) => {
              this.$nextTick(() => {
                // this.$refs.useTable.getRequestRes("firstPage");
              });
            },
          },
          childSlot: statusList.map((item) => {
            return {
              Component: "el-option",
              componentProps: {
                label: item.label,
                value: item.value,
                key: item.value,
              },
            };
          }),
        },
        {
          Component: "el-button",
          span: 2,
          componentProps: {
            type: "primary",
          },
          renderHTML: () => {
            return "查询";
          },
          on: {
            click: () => {
              this.$refs.useTable.getRequestRes("firstPage");
            },
          },
        },
      ],
    };
  },
  components: {
    useTable
  },
  created() {
    this.merchant_meta_no = this.$route.params.id ? this.$route.params.id : "";
  },
  methods: {
    ...mapActions('coupon',['couponRecodee']),

    async httprequest(params) {
      this.searchParams = params;
      this.searchParams.merchant_meta_no = this.merchant_meta_no
      let res = await this.couponRecodee(params);
      let keys = {
        data: res.list,
        total: res.count,
      };
      return keys;
    }
  }
};
</script>